export enum AppUpdateType {
  MAJOR = 'major',
  MINOR = 'minor',
  NONE = 'none'
}
